import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  IHrVenturePointsPaginatedResponse,
  getHrVenturePointsListPaginated,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { HrVenturePointsModalMode } from "./enums";
import { IHrVenturePointsModalData } from "./types";

const initialState = {
  hrVenturePointsData: null as Nullable<
    IHrVenturePointsPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: HrVenturePointsModalMode.VIEW,
    open: false,
    loading: false,
  } as IHrVenturePointsModalData,
};

export const fetchHrVenturePointsList = createAsyncThunk(
  "hr/fetchHrVenturePointsList",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getHrVenturePointsListPaginated(filters);
    return response;
  }
);

const hrVenturePointsSlice = createSlice({
  name: "hrVenturePoints",
  initialState,
  reducers: {
    setHrVenturePointsModalData: (
      state,
      action: PayloadAction<IHrVenturePointsModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeHrVenturePointsModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setHrVenturePointsModalLoading: (state, action: PayloadAction<boolean>) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHrVenturePointsList.fulfilled, (state, action) => {
      if (!action.payload) return;
      return {
        ...state,
        hrVenturePointsData: action.payload
          ?.edges as IHrVenturePointsPaginatedResponse["edges"],
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchHrVenturePointsList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setHrVenturePointsModalData,
  closeHrVenturePointsModal,
  setHrVenturePointsModalLoading,
} = hrVenturePointsSlice.actions;

export default hrVenturePointsSlice.reducer;
